import type { RouteRecordRaw } from 'vue-router';

import MonitorForDevelopersRouteName from './MonitorForDevelopersRouteName';

const MonitorMessages = async () => import('./monitor-messages/MonitorMessages.vue');
const MonitorBuildInfo = async () => import('./monitor-build-info/MonitorBuildInfo.vue');
const MonitorClicker = async () => import('./monitor-clicker/MonitorClicker.vue');
const MonitorDebugSettings = async () => import('./monitor-debug-settings/MonitorDebugSettings.vue');
const MonitorSeed = async () => import('./monitor-seed/MonitorSeed.vue');

const MonitorPageForDevelopers = async () => import('../../../pages/MonitorPageForDevelopers.vue');

export default function getMonitorForDevelopersRoutes(): RouteRecordRaw[] {
  return [
    {
      children: [
        {
          component: MonitorBuildInfo,
          meta: {
            title: 'Build info - Monitor for developers',
          },
          name: MonitorForDevelopersRouteName.BUILD_INFO,
          path: 'build-info',
        },
        {
          component: MonitorDebugSettings,
          meta: {
            title: 'Debug settings - Monitor for developers',
          },
          name: MonitorForDevelopersRouteName.DEBUG_SETTINGS,
          path: 'debug-settings',
        },
        {
          component: MonitorSeed,
          meta: {
            title: 'Seed - Monitor for developers',
          },
          name: MonitorForDevelopersRouteName.SEED,
          path: 'seed',
        },
        {
          component: MonitorClicker,
          meta: {
            title: 'Clicker - Monitor for developers',
          },
          name: MonitorForDevelopersRouteName.CLICKER,
          path: 'clicker',
        },
        {
          component: MonitorMessages,
          meta: {
            title: 'Messages - Monitor for developers',
          },
          name: MonitorForDevelopersRouteName.MESSAGES,
          path: 'messages',
        },
      ],
      component: MonitorPageForDevelopers,
      meta: {
        title: 'Monitor for developers',
      },
      name: MonitorForDevelopersRouteName.MAIN,
      path: '/monitor/developer',
      redirect: {
        name: MonitorForDevelopersRouteName.BUILD_INFO,
      },
    },
  ];
}
